import styled from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  p {
    margin: 0;
    padding: 0;
    line-height: 24px;
    font-family: inherit;
    color: ${colors.gray900};
  }
`;

export const Title = styled.p`
  font-size: 16px;
  font-weight: 600;

  .ant-collapse.small & {
    font-size: 14px;
  }
`;

export const Description = styled.p`
  font-size: 14px;
  font-weight: 400;

  .ant-collapse.small & {
    line-height: 16px;
    font-size: 12px;
  }
`;
